import Vue from 'vue'
import Cookies from 'js-cookie'
import DefaultLanguage from '@/core/js/DefaultLanguage'
import Settings from '@/config/Settings'

const route = {
  name: null,
  meta: {
    lang: DefaultLanguage,
    name: null
  }
}

export default {
  namespaced: true,
  state: {
    lang: DefaultLanguage,
    mode: Settings.mode,
    route: {
      from: route,
      to: route
    },
    archives: null,
    artwork: null,
    render: true,
    oeuvres: null,
    sound: null,
    ambiance: null,
    match: [],
    pages: {
      'options/aventure': null,
      'options/en-classe': null,
      'options/equipe': null,
      'options/glossaire': null,
    },
    current_drag: null,
    drag_back: null,
    drag_end: null,
    categorie: 'backgrounds',
    portrait: {
      backgrounds: null,
      silhouettes: null, 
      hair: null, 
      mouths: null, 
      eyes: null, 
      eyebrows: null,  
      noses: null, 
      clothing: null, 
      accessories: null,
      other: null  
    },
    colors: {
      backgrounds: null,
      silhouettes: null, 
      hair: null, 
      mouths: null, 
      eyes: null, 
      eyebrows: null,  
      noses: null, 
      clothing: null, 
      accessories: null,
      other: null  
    },
    history: [],
    color: 'grey',
    reset_color: 0,
    narration_muted: false,
    is_over: null,
    base_64: null,
    call_next: 0,
    is_locked: true,
    stickers_finded: [],
    video_is_playing: false,
    hide_bubble: 0,
    request_needed: true
  },
  mutations: {
    'SET_SOUND' (state, sound) {
      state.sound = sound
    },
    'SET_AMBIANCE' (state, ambiance) {
      state.ambiance = ambiance
    },
    'SET_OEUVRE' (state, name) {
      _.each(state.oeuvres, (o,k) => {
        state.oeuvres[k].is_active = false
        if(o.name == name) {
          state.oeuvres[k].is_active = true
        }
      })
    },
    'SET_DATA' (state, obj) {
      if(obj.type == 'oeuvres') {
        _.each(obj.data, (o,k) => {
          obj.data[k]['is_active'] = false
        })
        state.oeuvres = obj.data
      }

      if(['options/aventure', 'options/en-classe', 'options/equipe', 'options/glossaire'].indexOf(obj.type) > -1)
        state.pages[obj.type] = obj.data

      if(obj.type == 'oeuvres_archives')
        state.archives = _.sampleSize(obj.data, 4)

      if(state.oeuvres && state.archives) {
        state.archives = _.filter(state.archives, archive => {
          const oeuvre = _.find(state.oeuvres, oeuvre => oeuvre.archive == archive.id)
          if(oeuvre) {
            archive.oeuvre = oeuvre.id
            return oeuvre
          }
        })
      }
    },
    'SET_RENDER' (state, bool) {
      state.render = bool
    },
    'SET_ARTWORK' (state, arg) {
      state.artwork = arg
    },
    'SET_MATCH' (state, id) {
      state.match.push(id)
    },
    'SET_MODE' (state, mode) {
      state.mode = mode
    },
    'RESET_MODE' (state) {
      state.mode = Settings.mode
    },
    'SET_FROM_ROUTE' (state, from) {
      state.route.from = from
    },
    'SET_TO_ROUTE' (state, to) {
      state.route.to = to
    },
    'LANG_REFRESH' (state) {
      const l = state.lang
      state.lang = 'none'
      state.lang = l
    },
    'LANG_CHANGED' (state, lang) {
      state.lang = lang
      Cookies.set(Settings.cookies.lang, state.lang)
    },
    'CURRENT_DRAG' (state, data) {
      state.current_drag = data
    },
    'DRAG_BACK' (state, data) {
      state.drag_back = data
    },
    'DRAG_END' (state, data) {
      state.drag_end = data
    },
    'IS_OVER' (state, data) {
      state.is_over = data
    },
    'SET_PORTRAIT' (state, data) {
      state.portrait[data.categorie] = data.value
      state.history.push(data)
    },
    'SET_CATEGORIE' (state, data) {
      state.categorie = data
    },
    'SET_HISTORY' (state, data) {
      state.history.push(data)
    },
    'ERASE' (state) {
      state.history = []
      state.categorie = 'empty'
      state.portrait = {
        backgrounds: null,
        silhouettes: null, 
        hair: null, 
        mouths: null, 
        eyes: null, 
        eyebrows: null,  
        noses: null, 
        clothing: null, 
        accessories: null,
        other: null  
      } 
      state.colors = {
        backgrounds: null,
        silhouettes: null, 
        hair: null, 
        mouths: null, 
        eyes: null, 
        eyebrows: null,  
        noses: null, 
        clothing: null, 
        accessories: null,
        other: null  
      } 
    },
    'UNDO_HISTORY' (state) {
      let arr = []
      let clone = _.clone(state.history)
      let last = _.last(clone)
      _.each(clone, (cue)=>{
        if(cue.value != last.value)
          arr.push(cue)
      })
      state.history = arr
      console.log('undo');
    },
    'SET_COLOR' (state, data) {
      state.color = data
      state.colors[state.categorie] = data
    },
    'RESET_COLOR' (state, data) {
      state.reset_color += 1
    },
    'NARRATION_MUTED' (state, b) {
      state.narration_muted = b
    },
    'UPDATE_BASE_64' (state, data) {
      state.base_64 = data
    },
    'CALL_NEXT' (state) {
      state.call_next += 1
    },
    'IS_LOCKED' (state, b) {
      state.is_locked = b
    },
    'ADD_STICKERS' (state, array) {
      const nw = _.concat(state.stickers_finded, array)
      state.stickers_finded = nw
    },
    'VIDEO_IS_PLAYING' (state, b) {
      console.log('x');
      state.video_is_playing = b
    },
    'HIDE_BUBBLE'(state) {
      state.hide_bubble += 1
    },
    'UPDATE_REQUEST'(state, status) {
      state.request_needed = status
    }
  },
  getters: {
    lang: state => state.lang,
    mode: state => state.mode,
    route: state => state.route,
    archives: state => state.archives,
    artwork: state => state.artwork,
    render: state => state.render,
    oeuvres: state => state.oeuvres,
    match: state => state.match,
    sound: state => state.sound,
    ambiance: state => state.ambiance,
    pages: state => state.pages,
    current_drag: state => state.current_drag,
    drag_back: state => state.drag_back,
    drag_end: state => state.drag_end,
    categorie: state => state.categorie,
    portrait: state => state.portrait,
    history: state => state.history,
    color: state => state.color,
    colors: state => state.colors,
    reset_color: state => state.reset_color,
    narration_muted: state => state.narration_muted,
    is_over: state => state.is_over,
    base_64: state => state.base_64,
    call_next: state => state.call_next,
    is_locked: state => state.is_locked,
    stickers_finded: state => state.stickers_finded,
    video_is_playing: state => state.video_is_playing,
    hide_bubble: state => state.hide_bubble,
    request_needed: state => state.request_needed,
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/App.js